import { makeStyles } from 'tss-react/mui';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import MenuBookOutlinedIcon from '@mui/icons-material/MenuBookOutlined';
import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

const DOC_SETS = [
  {
    title: 'Internal Developer Portal',
    description:
      'Learn what the IDP has to offer, and how to use each portal feature — from catalog, documentation and workflows.',
    url: 'https://idp.oneadvanced.io/docs/default/component/oneadvanced-internal-developer-portal-docs',
    IconComponent: MenuBookOutlinedIcon,
  },
  {
    title: 'Platform — Developer Experience',
    description:
      'Onboard to the platform, access the engineering toolchain, understand standards, access innovation accounts, and find out how to get support.',
    url: 'https://idp.oneadvanced.io/docs/default/component/platform-dev-experience-docs',
    IconComponent: BuildOutlinedIcon,
  },
];

const useStyles = makeStyles()((theme) => ({
  banner: {
    position: 'relative',
    marginBottom: theme.spacing(3),
    padding: theme.spacing(3),
    borderRadius: theme.shape.borderRadius,
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.04)'
        : 'rgba(25, 118, 210, 0.04)',
    border: `1px solid ${theme.palette.divider}`,
  },
  headline: {
    fontWeight: 600,
    marginBottom: theme.spacing(0.5),
  },
  subtext: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2.5),
  },
  docCard: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    transition: 'box-shadow 0.2s',
    '&:hover': {
      boxShadow: theme.shadows[4],
    },
  },
  cardContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  iconRow: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  icon: {
    marginRight: theme.spacing(1),
  },
  docTitle: {
    fontWeight: 600,
  },
  docDescription: {
    flex: 1,
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(2),
  },
  openButton: {
    alignSelf: 'flex-start',
    textTransform: 'none',
  },
}));

export const GettingStartedPanel = () => {
  const { classes } = useStyles();

  return (
    <div className={classes.banner}>
      <Typography variant="h6" className={classes.headline}>
        Start with these guides
      </Typography>
      <Typography variant="body2" className={classes.subtext}>
        Everything you need to know about the IDP and the platform developer experience, in one place. Click below to open the docs in a new tab.
      </Typography>
      <Grid container spacing={2}>
        {DOC_SETS.map(({ title, description, url, IconComponent }) => (
          <Grid item xs={12} md={6} key={title}>
            <Card
              className={classes.docCard}
              elevation={1}
            >
              <CardContent className={classes.cardContent}>
                <div className={classes.iconRow}>
                  <IconComponent
                    className={classes.icon}
                  />
                  <Typography variant="subtitle1" className={classes.docTitle}>
                    {title}
                  </Typography>
                </div>
                <Typography variant="body2" className={classes.docDescription}>
                  {description}
                </Typography>
                <Button
                  className={classes.openButton}
                  variant="outlined"
                  size="small"
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  endIcon={<OpenInNewIcon fontSize="small" />}
                >
                  Open Docs
                </Button>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};
